import { render, staticRenderFns } from "./partner-contract-details-container.vue?vue&type=template&id=48148542&scoped=true&lang=pug"
import script from "./partner-contract-details-container.vue?vue&type=script&lang=ts"
export * from "./partner-contract-details-container.vue?vue&type=script&lang=ts"
import style0 from "./partner-contract-details-container.vue?vue&type=style&index=0&id=48148542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48148542",
  null
  
)

export default component.exports